import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Avatar,
  Badge,
  Box,
  Button,
  Hidden,
  IconButton,
  Menu,
  MenuItem
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';

import Notifier from 'src/app/components/notification/Notifier';
import InnerProfileMenu from './InnerProfileMenu';
import WalletTopupDialog from './WalletTopupDialog';

const languageMenuItems = [
  {
    label: 'English',
    src: '/static/images/en-square-flag.png'
  },
  {
    label: '中文',
    src: '/static/images/cn-square-flag.png'
  },
  {
    label: 'ພາສາລາວ',
    src: '/static/images/lao-square-flag.png'
  }
];

const renderLanguageItems = () =>
  languageMenuItems.map(item => (
    <MenuItem key={item.label} onClick={() => {}}>
      <img
        style={{
          width: '20px',
          borderRadius: '50%',
          marginRight: '5px'
        }}
        alt="Language "
        src={item.src}
      />
      {item.label}
    </MenuItem>
  ));

const TopBarUserActions = ({
  avatarImage,
  languageMenuAnchor,
  profileMenuAnchor,
  openLanguageMenu,
  closeLanguageMenu,
  openProfileMenu,
  closeProfileMenu,
  goProfile,
  handleLogOut,
  onOpenMobileMenu,
  showAlertButton,
  alertVehicleCount,
  alertBadgeClassName,
  onOpenAlertModal
}) => {
  const [openTopup, setOpenTopup] = useState(false);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const walletBalance = useSelector(state => state.authSlice.walletBalance);
  const agencyLevel = Number(useSelector(state => state.authSlice.agencyLevel));

  return (
    <>
      <WalletTopupDialog open={openTopup} onClose={() => setOpenTopup(false)} />
      <Hidden mdDown>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          {showAlertButton && (
            <IconButton
              aria-controls="alert"
              aria-haspopup="true"
              onClick={onOpenAlertModal}
            >
              <Badge
                badgeContent={alertVehicleCount}
                max={99}
                className={alertBadgeClassName}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
              >
                <Avatar
                  src="/static/iconSvg/alert.svg"
                  style={{ height: 22, width: 22 }}
                />
              </Badge>
            </IconButton>
          )}

          {isAgency && agencyLevel === 1 && (
            <Button
              id="wallet-topup-btn"
              onClick={() => setOpenTopup(true)}
              startIcon={<AccountBalanceWalletIcon style={{ fontSize: 18 }} />}
              style={{
                textTransform: 'none',
                marginRight: 4,
                borderRadius: 20,
                padding: '4px 14px',
                background: 'linear-gradient(135deg, #D9042F, #b00223)',
                color: '#fff',
                fontSize: 13,
                fontWeight: 600,
                boxShadow: '0 2px 8px rgba(217,4,47,0.4)',
                whiteSpace: 'nowrap'
              }}
            >
              {walletBalance !== null
                ? Number(walletBalance).toLocaleString('vi-VN') + ' Vxu'
                : '--- Vxu'}
            </Button>
          )}

          <Notifier />

          <IconButton
            aria-controls="lang-menu"
            aria-haspopup="true"
            onClick={openLanguageMenu}
          >
            <Avatar
              src="/static/images/vn-square-flag.png"
              style={{ height: 28, width: 28 }}
            />
          </IconButton>

          <Menu
            id="lang-menu"
            anchorEl={languageMenuAnchor}
            keepMounted
            open={Boolean(languageMenuAnchor)}
            onClose={closeLanguageMenu}
          >
            {renderLanguageItems()}
          </Menu>

          <IconButton
            aria-controls="profile-menu"
            aria-haspopup="true"
            onClick={openProfileMenu}
          >
            <Avatar
              src={avatarImage}
              alt="avatar"
              style={{ height: 30, width: 30 }}
            />
          </IconButton>

          <Menu
            id="profile-menu"
            anchorEl={profileMenuAnchor}
            keepMounted
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            open={Boolean(profileMenuAnchor)}
            onClose={closeProfileMenu}
          >
            <InnerProfileMenu
              handleLogOut={handleLogOut}
              goProfile={goProfile}
              avatarImage={avatarImage}
            />
          </Menu>
        </Box>
      </Hidden>


      <Hidden lgUp>
        <Box width={1} display="flex" alignItems="center" justifyContent="flex-end">
          {showAlertButton && (
            <IconButton
              aria-controls="alert"
              aria-haspopup="true"
              onClick={onOpenAlertModal}
            >
              <Badge
                badgeContent={alertVehicleCount}
                max={99}
                className={alertBadgeClassName}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
              >
                <Avatar
                  src="/static/iconSvg/alert.svg"
                  style={{ height: 22, width: 22 }}
                />
              </Badge>
            </IconButton>
          )}

          {isAgency && agencyLevel === 1 && (
            <IconButton
              id="wallet-topup-mobile-btn"
              onClick={() => setOpenTopup(true)}
              style={{ color: '#D9042F' }}
            >
              <AccountBalanceWalletIcon />
            </IconButton>
          )}

          <Notifier />

          <IconButton
            aria-controls="mobile-profile-menu"
            aria-haspopup="true"
            onClick={openProfileMenu}
          >
            <Avatar
              src={avatarImage}
              alt="avatar"
              style={{ height: 30, width: 30 }}
            />
          </IconButton>

          <Menu
            id="mobile-profile-menu"
            anchorEl={profileMenuAnchor}
            keepMounted
            open={Boolean(profileMenuAnchor)}
            onClose={closeProfileMenu}
          >
            <MenuItem onClick={goProfile}>Tài khoản của tôi</MenuItem>
            <MenuItem onClick={handleLogOut}>Đăng xuất</MenuItem>
          </Menu>

          <Menu
            id="mobile-lang-menu"
            anchorEl={languageMenuAnchor}
            keepMounted
            open={Boolean(languageMenuAnchor)}
            onClose={closeLanguageMenu}
          >
            {renderLanguageItems()}
          </Menu>

          <IconButton
            aria-controls="mobile-lang-menu"
            aria-haspopup="true"
            onClick={openLanguageMenu}
          >
            <Avatar
              src="/static/images/vn-square-flag.png"
              style={{ height: 28, width: 28 }}
            />
          </IconButton>

          <IconButton onClick={onOpenMobileMenu}>
            <MenuIcon />
          </IconButton>
        </Box>
      </Hidden>
    </>
  );
};


TopBarUserActions.propTypes = {
  avatarImage: PropTypes.string.isRequired,
  languageMenuAnchor: PropTypes.any,
  profileMenuAnchor: PropTypes.any,
  openLanguageMenu: PropTypes.func.isRequired,
  closeLanguageMenu: PropTypes.func.isRequired,
  openProfileMenu: PropTypes.func.isRequired,
  closeProfileMenu: PropTypes.func.isRequired,
  goProfile: PropTypes.func.isRequired,
  handleLogOut: PropTypes.func.isRequired,
  onOpenMobileMenu: PropTypes.func.isRequired,
  showAlertButton: PropTypes.bool,
  alertVehicleCount: PropTypes.number,
  alertBadgeClassName: PropTypes.string,
  onOpenAlertModal: PropTypes.func
};

export default TopBarUserActions;
